var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#026899"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26767_6857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0252 16.625H11V29H15.0252V16.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9895 16.7701C25.9468 16.7566 25.9062 16.742 25.8612 16.7296C25.8073 16.7172 25.7532 16.7071 25.6981 16.6981C25.4844 16.6554 25.2504 16.625 24.9759 16.625C22.6291 16.625 21.1407 18.3316 20.6502 18.9909V16.625H16.625V29H20.6502V22.25C20.6502 22.25 23.6923 18.0132 24.9759 21.125C24.9759 23.9026 24.9759 29 24.9759 29H29V20.6491C29 18.7794 27.7186 17.2213 25.9895 16.7701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9688 14.9375C14.0561 14.9375 14.9375 14.0561 14.9375 12.9688C14.9375 11.8814 14.0561 11 12.9688 11C11.8814 11 11 11.8814 11 12.9688C11 14.0561 11.8814 14.9375 12.9688 14.9375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26767_6857"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.f5a4793a03499c1b7af69354b2a06165.svg";
export { ForwardRef as ReactComponent };